import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { PAGES, ROUTES } from './EInvoicingPortal.config';
import { Dashboard } from '../../components/Dashboard';
import { useAuthentication } from '../../hooks/useAuthentication';
import { Button } from 'primereact/button';
import { getAssetUrl } from '../../services/apis';
import { showToast } from '../../helpers/showToast';
import styles from './EInvoicingPortal.styles.scss';
const EInvoicingPortal = () => {
  const [pages, setPages] = useState([]);
  const [isDownloading, setIsDownloading] = useState(false);
  const { t } = useTranslation();
  const { hasRole } = useAuthentication();

  useEffect(() => {
    setPages(PAGES(hasRole));
  }, [hasRole]);

  const handleDownloadManual = async () => {
    setIsDownloading(true);
    try {
      const response = await getAssetUrl('raseed-user-manual-clean');
      const { url } = response.data;

      if (url) {
        window.open(url, '_blank');
      }
    } catch (error) {
      showToast({
        data: {
          type: 'error',
          message: t('failed_to_download_manual'),
        },
      });
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <Dashboard
      isEInvoicing={true}
      title={t('e_invoicing_portal_header')}
      routes={ROUTES}
      pages={pages}
      tileId={'e_invoicing'}
      withBreadcrumb={false}
      withActionButton={true}
      action={
        <Button
          className={styles.button}
          onClick={handleDownloadManual}
          disabled={isDownloading}
          loading={isDownloading}
        >
          {t('e_invoicing_portal_action_button')}
        </Button>
      }
    />
  );
};

export default React.memo(EInvoicingPortal);
